import { useMemo } from 'react';
import classNames from 'classnames';
import CTNInput from '@ctn/ui/components/ctn-input';
import CTNButton from '@ctn/ui/components/ctn-button';
import { useForm } from 'react-hook-form';

type CatalogSearcherProps = {
	readonly className?: string;
};

type SearchForm = {
	title: string;
};

const classNameComponent = 'c-cnm-catalog-searcher';

export const CatalogSearcher = ({ className }: CatalogSearcherProps) => {
	const wrapperClassName = classNames(classNameComponent, className);
	const form = useForm<SearchForm>({
		defaultValues: { title: '' },
		mode: 'onSubmit',
	});
	const { control } = form;

	return (
		<section className={wrapperClassName}>
			<h3 className={`${classNameComponent}__title`}>Buscar publicación</h3>
			<form className={`${classNameComponent}__form`} role="search">
				<CTNInput
					type="text"
					name="title"
					control={control}
					classNameInput={`${classNameComponent}__input`}
					classNameField={`${classNameComponent}__field`}
				/>
				<CTNButton
					type="button"
					variant="solid"
					mode="primary"
					className={`${classNameComponent}__btn`}
					label="Buscar"
				/>
			</form>
		</section>
	);
};
